import { formatPhoneNumber as reactFormatPhoneNumber } from "react-phone-number-input";

// Takes formatted phone numbers and strips everything but the numbers
export function cleanPhoneNumber(phoneNumber) {
  if (!phoneNumber || phoneNumber.length <= 0) {
    return;
  }

  const cleanNumber = phoneNumber
    .replace(/\s/g, "")
    .replace(/_/g, "")
    .replace(/[{()}]+/g, "")
    .replace(/-/g, "");

  if (cleanNumber === "+1") {
    return "";
  }
  return cleanNumber;
}

export function formatPhoneNumber(phoneNumber) {
  return reactFormatPhoneNumber(phoneNumber);
}

// Tests to see if user has entered a valid phone number
// Always assume a number should have only numbers and a length of 12 (+, leading country code)
export function validatePhoneNumber(phoneNumber) {
  if (!phoneNumber) {
    return false;
  }
  if (phoneNumber.length !== 12) return false;
  if (phoneNumber[0] !== "+") return false;
  const numberAfterPrefix = phoneNumber.substring(1);
  return /^\d+$/.test(numberAfterPrefix);
}

export function isCellNumber(x) {
  const y = cleanPhoneNumber(x.substr(1, x.length));
  return y.match(/^[0-9]+$/) != null;
}
